import {useRef} from 'react';
import {useCurrentLanguage} from 'hooks/useCurrentLanguage';
import LanguageSelection, {
  LanguageSelectionRef,
} from 'components/ModalSheets/LanguageSelection';
import styles from './styles.module.css';

function LanguageButton() {
  const config = useCurrentLanguage();
  const languageSelectionModalRef = useRef<LanguageSelectionRef>(null);
  if (!config) {
    return null;
  }

  return (
    <>
      <button
        className={styles.languageButton}
        onClick={languageSelectionModalRef.current?.open}
        type="button"
        aria-label={`Change language from ${config.label}`}
      >
        <img
          src={config.flag}
          alt={`${config.label} flag`}
          className={styles.flagImage}
          width={20}
          height={20}
        />
        <span className={styles.languageLabel}>{config.label}</span>
      </button>
      <LanguageSelection ref={languageSelectionModalRef} />
    </>
  );
}

export {LanguageButton};
